export const convertToKoreanNumber = (number: number) => {
  const koreanNumber = new Intl.NumberFormat("ko-KR").format(number);
  return koreanNumber;
};

export const formatPhoneNumber = (phoneNumber: string) => {
  const cleaned = ("" + phoneNumber).replace(/\D/g, "");
  const match = cleaned.match(/^(\d+)(\d{4})(\d{4})$/);
  if (match) {
    return match[1] + "-" + match[2] + "-" + match[3];
  }
  return null;
};

export const formatCount = (
  count: number,
  max: number = 999,
  isReverse: boolean = false
) => {
  const realCount = count ?? 0;

  return realCount > max
    ? isReverse
      ? `+${max}`
      : `${max}+`
    : isReverse
    ? `+${realCount}`
    : realCount;
};
